import { type RequestedResponder } from '@atlassian/eoc-schedule-common';

import { type RotationDetail } from '../../../common/types';

/**
 * Current step for edit mode
 */
export enum EditStep {
	/** @description Listing timeline rotations. */
	List = 1,
	/** @description Rotation details (add, edit, clone) */
	Detail,
}

/**
 * Detail rotation variants
 */
export enum RotationDetailVariant {
	Add = 1,
	Edit,
	Clone,
}

export type RecipientUpdate = {
	responders: RequestedResponder<true, true>[];
	startTime: string;
	shiftable: boolean;
};

export type EditStore = {
	orderRotationLoading: boolean;
	step: EditStep;
	rotationDetailVariant?: RotationDetailVariant;
	initialRotation?: RotationDetail;
	recipientUpdate?: RecipientUpdate;
};
